// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* for browser compatibility */
/* <link rel="stylesheet" href="reset.css">
   <link rel="stylesheet" href="style.css"
*/

:root {
  line-height: 1.5;
}

h1,
h2,
h3,
h4,
h5,
figure,
p,
ol,
ul {
  margin: 0;
}

ol[role="list"],
ul[role="list"],
li,
a {
  text-decoration: none;
  list-style: none;
  padding-inline: 0;
}

h1,
h2,
h3,
h4,
h5 {
  font-size: inherit;
  font-weight: inherit;
}

img {
  display: block;
  max-inline-size: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/reset.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;;CAEC;;AAED;EACE,gBAAgB;AAClB;;AAEA;;;;;;;;;EASE,SAAS;AACX;;AAEA;;;;EAIE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;;;EAKE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB","sourcesContent":["/* for browser compatibility */\n/* <link rel=\"stylesheet\" href=\"reset.css\">\n   <link rel=\"stylesheet\" href=\"style.css\"\n*/\n\n:root {\n  line-height: 1.5;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nfigure,\np,\nol,\nul {\n  margin: 0;\n}\n\nol[role=\"list\"],\nul[role=\"list\"],\nli,\na {\n  text-decoration: none;\n  list-style: none;\n  padding-inline: 0;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5 {\n  font-size: inherit;\n  font-weight: inherit;\n}\n\nimg {\n  display: block;\n  max-inline-size: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
